module.exports = __webpack_public_path__ + "images/icons/list-marker-disc.svg";